module.exports = __webpack_public_path__ + "media/5.cd364a05.mp3";